import * as React from "react";
import type { SVGProps } from "react";
const SvgSportsLeisure = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#sports-leisure_svg__a)">
      <path d="M8 22H4a1 1 0 1 1 0-2h3.38l1.23-2.45a1 1 0 1 1 1.78.9l-1.5 3A1 1 0 0 1 8 22M17 22a1 1 0 0 1-1-.8l-.82-4.2H11a1 1 0 0 1-.77-.37 1 1 0 0 1-.23-.83l1-5a1.02 1.02 0 1 1 2 .4l-.78 3.8H16a1 1 0 0 1 1 .8l1 5a1 1 0 0 1-.8 1.2z" />
      <path d="M20 15a1 1 0 0 1-.35-.06l-7.71-2.89L4.24 14a1.028 1.028 0 1 1-.48-2l8-2a1 1 0 0 1 .59 0l8 3a1.015 1.015 0 0 1-.35 2M12 9.26a2.78 2.78 0 0 1-2.78-2.77v-.71a2.78 2.78 0 0 1 5.56 0v.71A2.78 2.78 0 0 1 12 9.26M12 5a.78.78 0 0 0-.78.78v.71a.78.78 0 1 0 1.56 0v-.71A.78.78 0 0 0 12 5" />
    </g>
    <defs>
      <clipPath id="sports-leisure_svg__a">
        <path fill="#fff" d="M3 3h18v19H3z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSportsLeisure;
